import React from "react";

function Texmex() {
  return (
    <div class="wrapper" id="menu">
      <div class="title">
        <h4 style={{ textAlign: "center" }}>
          <span>voici nos Texmex N'hésitez pas appelez le 09 50 85 13 53</span>
          Tex Mex{" "}
        </h4>
      </div>
      <div class="menu">
        <div class="single-menu">
          <img src="https://www.mimifood.fr/produit/2219_152.png" alt="" />
          <div class="menu-content">
            <h4>
              {" "}
              6 Nuggets <span>5€</span>
            </h4>
            <p>Servi avec deux sauces au choix</p>
          </div>
        </div>
        <div class="single-menu">
          <img
            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT-UIp8p9bqnrHnj8KEHMi3B6oPUiT6L3jsWkp64ojm8SQpXopzMGa9bNy_4215_RHwoZg&usqp=CAU"
            alt=""
          />
          <div class="menu-content">
            <h4>
              4 Tenders gourmands <span>6€</span>
            </h4>
            <p>Servi avec deux sauces au choix</p>
          </div>
        </div>
        <div class="single-menu">
          <img
            src="https://www.scala-pizza.fr/wp-content/uploads/chicken-wings.jpg"
            alt=""
          />
          <div class="menu-content">
            <h4>
              6 Wings<span>5€</span>
            </h4>
            <p>Servi avec deux sauces au choix</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Texmex;
